import { render, staticRenderFns } from "./pengajuanAdd.vue?vue&type=template&id=7ffc3d22&scoped=true"
import script from "./pengajuanAdd.vue?vue&type=script&lang=js"
export * from "./pengajuanAdd.vue?vue&type=script&lang=js"
import style0 from "./pengajuanAdd.vue?vue&type=style&index=0&id=7ffc3d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc3d22",
  null
  
)

export default component.exports